<script>
import urlParser from 'js-video-url-parser'
import axios from 'axios'
export default 
{
    name: 'mv-video',

    methods:
    {
        onVideoInput(evt)
        {
            const value = evt.target.value
            if (value && value.includes('http'))
            {
                try {
                    const parsed = urlParser.parse(value)
                    if (parsed && parsed.mediaType == 'video' && parsed.provider == 'youtube')
                    {
                        this.internalVideoId = parsed.id
                        this.videoId = parsed.id
                        return
                    }
                } catch (e) {}
            }
            this.internalVideoId = value
            this.videoId = value
        },

        addVideo()
        {
            if (this.videoId)
            {
                axios.post(`${process.env.API_URL}/v1/admin/video`, { video: this.videoId }).then(res => {
                    this.$emit('upload-done', res.data)
                    this.internalVideoId = null
                    this.videoId = null
                })
            }
        }
    },

    data()
    {
        return {
            internalVideoId: null,
            videoId: null,
        }
    },

}
</script>

<template>
<div>
    <div class="row">
        <div class="col-sm-10">
            <input class="form-control" @input="onVideoInput" :value="videoId">
        </div>

        <div class="col-sm-2">
            <button class="btn btn-primary" @click.prevent.stop="addVideo">Hozzáad</button>
        </div>
    </div>
    <div class="row" v-if="internalVideoId">
        <div class="col-sm-12 text-center">
            <iframe width="320" height="160" :src="'https://www.youtube.com/embed/' + internalVideoId" allowFullScreen="true">

            </iframe>
        </div>
    </div>
</div>
</template>



// WEBPACK FOOTER //
// src/components/Video.vue